module.exports = __webpack_public_path__ + "static/media/riven.34708e44.png";